import styled from "styled-components";

export const TOQtyModalWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1em;

  p {
    margin: 0;
  }

  .title {
    margin-right: auto;
    font-size: 20px;
    font-weight: 600;
    color: var(--dark);
  }

  .subtitle {
    font-size: 14px;
    color: var(--dark-light);
  }

  .batch span {
    color: var(--accent);
    font-weight: 600;
  }

  .batchMapping {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2em;
  }

  > div {
    width: 100%;
  }

  p.warning {
    /* font-size: 16px; */
    width: max-content;
    margin: 1em auto;
    padding: 0.5em 1.5em;
    border-radius: 100px;
    background: #fff0eb;
    color: var(--red);
    font-weight: 600;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 10px;
    animation: pulse-animation 2s infinite;
    svg {
      font-size: 18px;
    }
  }

  .binFull {
    margin-top: 2em;
    svg {
      font-size: 20px;
    }
  }

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgba(255, 118, 19, 0.2);
    }
    75% {
      box-shadow: 0 0 0 10px rgba(255, 118, 19, 0);
    }
  }

  .rackSearch {
    margin-top: 1.5em;

    label {
      span {
        color: var(--accent);
        font-weight: 600;
      }
    }
  }
`;
